import { invariant } from '@mimir/common/util/invariant';
import { evalRawScript, getFresh } from './cep';
import type { AllNleActions, ICepBridgeClient } from '@mimir/primitive/premiere/cepBridgeClientType';
import { reconstitutedException } from '@mimir/common/util/exception';

export class CepBridgeClient implements ICepBridgeClient {
  initialized: boolean = false;
  async call<A extends keyof AllNleActions>(action: A, ...args: Parameters<AllNleActions[A]>): Promise<ReturnType<AllNleActions[A]>> {

    if (!this.initialized) {

      const bundle: string = await getFresh('/assets/cepbridge.jsx');
      const s = bundle.lastIndexOf('[') + 1;
      const e = bundle.indexOf(']', s);
      const id = bundle.slice(s, e);
      const initScript = '__require=' + bundle + ';cepbridge=__require(' + id + '); "OK"';
      const result = await evalRawScript(initScript);
      invariant(result == 'OK', 'Expected initialized cepbridge');
      this.initialized = true;
    }

    const callScript = 'cepbridge.call(' + JSON.stringify(action) + ',' + JSON.stringify(args) + ');';
    const reply = await evalRawScript(callScript);
    let obj: any;
    try {
      obj = JSON.parse(reply);
    } catch (_) {
      throw new Error(`cepbridge.call('${action}') failed: ${reply}`);
    }
    if (obj.error) {
      throw reconstitutedException(obj.error);
    }
    return obj.result;
  }
}
